var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnbwxg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4EAF94",
    d: "M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12s12-5.373 12-12c0-6.628-5.373-12-12-12Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0B90B",
    d: "M5.423 12 2.71 14.71 0 12l2.71-2.71L5.423 12ZM12 5.419l4.645 4.647 2.71-2.71L12 0 4.645 7.355l2.71 2.71L12 5.42Zm9.292 3.87L18.582 12l2.71 2.71L24 12l-2.708-2.71ZM12 18.582l-4.645-4.644-2.71 2.708L12 24l7.355-7.355-2.71-2.708L12 18.58Zm0-3.87L14.71 12 12 9.29 9.29 12 12 14.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M-3 14h29v7H-3z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.022 20H9.79v-.454h-.233v-.455h-.232v-.455h-.233v-.454H8.86v-.455h-.233v-.454h-.232v.454h-.233v.455H7.93v.454h-.233v.455h-.232v.454h-.233V20H7v-5h.697v2.5h.233v-.454h.232v-.455h.233v-.455h.232v.455h.233v.454h.232v.455h.233V15h.697v5ZM13.511 20h-.697v-.682h-.233v-.682h-.232v-.454h-.233v-.227h-.232v.227h-.233v.454h-.232v.682h-.233V20h-.697v-.682h.232v-.682h.233v-.454h.232v-.455h.233v-.454h-.233v-.455h-.232v-.454h-.233v-.682h-.232V15h.697v.682h.233v.682h.232v.454h.233v.227h.232v-.227h.233v-.454h.232v-.682h.233V15h.697v.682h-.232v.682h-.233v.454h-.232v.455h-.233v.454h.233v.455h.232v.454h.233v.682h.232V20ZM17 19.546h-.233v.227h-.232V20h-1.627v-.227h-.233v-.227h-.232v-.228h-.233v-.227h-.232v-3.182h.232v-.227h.233v-.228h.232v-.227h.233V15h1.627v.227h.232v.227H17v.455h-.698v-.227H15.14v.227h-.232v.227h-.233v2.728h.233v.227h.232v.227h1.162v-1.364h-.232v.228h-.697v-.91H17v2.274Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff",
    rx: 12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbwxg);
export default __webpack_public_path__ + "static/media/BNB WXG.d977bc1a623001fd0f3dbce88dbd394e.svg";
export { ForwardRef as ReactComponent };